export function tModule(
  t: (key: string) => unknown,
  moduleName: string,
  field: 'title' | 'description',
  systemName?: string
): string | null {
  const keys = systemName
    ? [`modules.${systemName}.${moduleName}.${field}`, `modules.${moduleName}.${field}`]
    : [`modules.${moduleName}.${field}`];
  for (const key of keys) {
    const val = t(key);
    if (typeof val === 'string' && val.length > 0 && val !== key) return val;
  }
  return null;
}

export function favoriteModuleKey(systemName: string, moduleName: string): string {
  return `${systemName}:${moduleName}`;
}

export function sanitizeFavoriteModuleKeys(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const seen = new Set<string>();
  const keys: string[] = [];
  for (const item of value) {
    if (typeof item !== 'string') continue;
    const key = item.trim();
    if (!/^[a-z0-9_-]+:[a-z0-9_/-]+$/i.test(key) || seen.has(key)) continue;
    seen.add(key);
    keys.push(key);
  }
  return keys;
}
